import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Play, Video, Check, Clock, Info } from 'lucide-react';
import VideoPlayer from './VideoPlayer';

const PostureAssessment = ({ posture, isCompleted, onStartRecording, recording }) => {
  const [showInstructions, setShowInstructions] = useState(true);

  const handleToggleInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  return (
    <div className="space-y-8">
      {/* Demo Video */}
      <div className="space-y-4">
        <h2 className="text-lg font-medium text-dark-200">Watch</h2>
        <VideoPlayer
          src={posture.videoUrl}
          title=""
          className="w-full"
        />
      </div>

      {/* Instructions */}
      <motion.div
        className="space-y-4"
        initial={false}
        animate={{
          opacity: showInstructions ? 1 : 0.7
        }}
      >
        <button
          onClick={handleToggleInstructions}
          className="flex items-center justify-between w-full text-left"
        >
          <h2 className="text-lg font-medium text-dark-200">Instructions</h2>
          <motion.div
            animate={{ rotate: showInstructions ? 180 : 0 }}
            transition={{ duration: 0.2 }}
          >
            <Info className="w-5 h-5 text-dark-400" />
          </motion.div>
        </button>

        <motion.div
          initial={false}
          animate={{
            height: showInstructions ? 'auto' : 0,
            opacity: showInstructions ? 1 : 0
          }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden"
        >
          <p className="text-dark-400 text-sm leading-relaxed">
            {posture.instructions}
          </p>
        </motion.div>
      </motion.div>

      {/* Recording Area */}
      <div className="space-y-4">
        <h2 className="text-lg font-medium text-dark-200">Record</h2>

        {/* Recording Area */}
        <div className="aspect-video bg-dark-800 rounded-lg border border-dark-700 flex items-center justify-center relative overflow-hidden">
          {recording ? (
            // Show recorded video
            <div className="w-full h-full relative">
              <video
                className="w-full h-full object-cover rounded-lg scale-x-[-1]"
                controls
                src={URL.createObjectURL(recording.blob)}
              />

              {/* Completed Overlay */}
              {isCompleted && (
                <motion.div
                  className="absolute top-3 right-3 bg-green-600 text-white px-2 py-1 rounded-full flex items-center space-x-1"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <Check className="w-3 h-3" />
                  <span className="text-xs font-medium">Done</span>
                </motion.div>
              )}
            </div>
          ) : (
            // Show recording prompt
            <div className="text-center p-6">
              <Video className="w-12 h-12 mx-auto mb-3 text-dark-500" />
              <p className="text-dark-400 text-sm">Tap to start camera</p>
            </div>
          )}
        </div>

        {/* Recording Controls */}
        <div className="space-y-3">
          <motion.button
            onClick={onStartRecording}
            className={`w-full py-3 rounded-lg font-medium transition-colors duration-200 ${
              recording
                ? 'bg-dark-800 text-dark-300 hover:bg-dark-700'
                : 'bg-white text-black hover:bg-gray-100'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {recording ? 'Retake' : 'Start Recording'}
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default PostureAssessment;
